import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx.js';

export interface CardProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode;
  /** Heading level of the title (default 2). */
  titleLevel?: 1 | 2 | 3;
  description?: ReactNode;
  padding?: 'md' | 'lg';
}

export function Card({
  title,
  titleLevel = 2,
  description,
  padding = 'md',
  className,
  children,
  ...rest
}: CardProps) {
  const Heading = `h${titleLevel}` as const;
  return (
    <section className={cx('qk-card', `qk-card--pad-${padding}`, className)} {...rest}>
      {title ? <Heading className="qk-card__title">{title}</Heading> : null}
      {description ? <p className="qk-card__description">{description}</p> : null}
      {children}
    </section>
  );
}
